<div class="planos-solucoes"><vfwc-contratacao-planos bg-image="images/bg-planos-solucoes.png" class="page-component"></vfwc-contratacao-planos></div>